const GetScopes = (appraisalLevelId, selectedEmployees, selectedLocations) => {
  let scopeArray = []

  if (appraisalLevelId > 0) {
    scopeArray = [...scopeArray, { ScopeType: 2, ScopeDetailId: appraisalLevelId }]
  }
  if (selectedEmployees.length > 0) {
    const employeeArray = selectedEmployees.map((emp) => {
      return {
        ScopeType: 1,
        ScopeDetailId: emp.employeeId,
        IncludeDirectReports: emp.includeDirectReports,
      }
    })
    scopeArray = [...scopeArray, ...employeeArray]
  }

  if (selectedLocations.length > 0) {
    const locationArray = selectedLocations.map((loc) => {
      return { ScopeType: 0, ScopeDetailId: loc }
    })
    scopeArray = [...scopeArray, ...locationArray]
  }

  return scopeArray
}

const GetQuestionDetails = (selected) => {
  return selected.map((question) => {
    return {
      DetailType: question.detailType,
      ClientWorkflowStepId: question.clientWorkflowStepId,
      FormQuestionId: question.questionId,
    }
  })
}

const GetSheetsFromExportTabs = (exportDetails) => {
  return exportDetails.map((tab, index) => {
    const questionDetails = GetQuestionDetails(tab.selectedQuestions)

    return {
      Title: tab.name,
      Sequence: index,
      Details: questionDetails,
    }
  })
}

const formatDataForReportSubmission = (data, cultureCode) => {
  const formattedData = {
    reportType: data.reportTypeId,
    reviewId: data.reviewId,
    includeLeavers: data.includeLeavers,
    sheets: GetSheetsFromExportTabs(data.exportDetails),
    employeeDetails: data.employeeDetailOptions,
    scopes: GetScopes(data.appraisalLevelId, data.selectedEmployees, data.selectedLocations),
    cultureCode,
  }

  return formattedData
}

export default formatDataForReportSubmission



// WEBPACK FOOTER //
// ./src/utils/customReport-utils.js